<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('aglevel.name')" class="mb-0">
							<el-input size="small" v-model="from.name" ></el-input>
						</el-form-item>
						
						
						
						
                       <el-form-item :label="$t('aglevel.type')" class="mb-0">
							<el-select v-model="from.type" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('aglevel.domain')" :value="1"></el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('layout.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('aglevel.add')}}</el-button>
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table :data="tableData" style="width: 100%" size="mini" @selection-change="handleSelectionChange">
				<el-table-column align="center" fixed prop="level" width="50" :label="$t('aglevel.level')">
				</el-table-column>
				
				<el-table-column align="center" prop="type" :label="$t('aglevel.type')">
					<template slot-scope="scope">
						<span v-if="scope.row.type==1">{{$t('aglevel.domain')}}</span>
					</template>
				</el-table-column>
				
				<el-table-column align="center"  prop="name" :label="$t('aglevel.name')">
				</el-table-column>
				
				
				<el-table-column align="center" prop="min" :label="$t('aglevel.min')">
				</el-table-column>
				<el-table-column align="center" prop="max" :label="$t('aglevel.max')">
				</el-table-column>
				
                <el-table-column align="center" prop="rebate" :label="$t('aglevel.rebate')">
					<template slot-scope="scope">
						{{scope.row.rebate}} %
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" prop="create_time" width="180" :label="$t('layout.createTime')">
				</el-table-column>
				
				
                
				
				<el-table-column align="center" width="90" fixed="right" :label="$t('layout.operation')">
					<template slot-scope="scope">
						<el-button-group>
							<el-button size="mini" plain type="success" v-auth="'editAdmin'" @click="openModel(scope)">{{$t('cdnd.edit')}}</el-button>
							<!-- <el-button @click="deleteItem(scope.row)" v-auth="'delAdmin'" size="mini" plain type="danger">{{$t('layout.delete')}}</el-button> -->
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>



		<el-footer
		class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		:style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		>
			<div style="flex: 1;" class="px-2">
				<el-pagination
				:current-page="page.current"
				:page-sizes="page.sizes"
				:page-size="page.size"
				@size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				background
				:layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
				:total="page.total"
				/>
			</div>
		</el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('aglevel.edit') : $t('aglevel.add')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				
                <el-form-item  :label="$t('aglevel.type')" prop="type">
                	<el-select  :disabled="editIndex > -1" v-model="form.type" size="small" filterable :placeholder="$t('system.select')">
                		
                		<el-option  :label="$t('aglevel.domain')" :value="1">
                		</el-option>
                	</el-select>
                </el-form-item>
				
				<el-form-item :label="$t('aglevel.name')" prop="name">
					<el-input v-model="form.name"  clearable size="small" :placeholder="$t('aglevel.name')"  style="width: 85%;"></el-input>
				</el-form-item>
				
                <el-form-item :label="$t('aglevel.level')" prop="level">
					<el-input :disabled="editIndex > -1" v-model="form.level"   :placeholder="$t('aglevel.level')" clearable size="small" type="number" style="width: 85%;" ></el-input>
				</el-form-item>
				<el-form-item :label="$t('aglevel.min')" prop="min">
					<el-input  v-model="form.min" type="number"  :placeholder="$t('aglevel.min')" clearable size="small" style="width: 85%;" ></el-input>
				</el-form-item>
				
				
				
				
				<el-form-item :label="$t('aglevel.max')" prop="max">
					<el-input  v-model="form.max" type="number"  :placeholder="$t('aglevel.max')" clearable size="small" style="width: 85%;" ></el-input>
				
					<div style="font-size: 12px;color: gray;">{{$t('aglevel.maxTis')}}</div>
				</el-form-item>
				
				<el-form-item :label="$t('aglevel.rebate')" prop="rebate">
					<el-input
					  v-model.number="form.rebate"
					  type="number"
					  :min="0"
					  :placeholder="$t('aglevel.rebate')" 
					  :max="100"
					  @input="limitRebate"
					  @change="limitRebate"
					  style="width: 85%;"
					>
					  <template slot="append">%</template>
					</el-input>
				</el-form-item>
				
				
				
               
				
				
               
				
			
                
                
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('system.cancel')}}</el-button>
				<el-button type="primary" :loading="layout.loading" :disabled="layout.loading" @click="submit">{{$t('system.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				createModel: false,
				editIndex: -1,
				rule:[],
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				},
				auth_val: 'Agent',

				preUrl: "user/agentlevelList", //列表地址
				// delAllUrl: "user/delAdminAll", //批量删除地址
				delUrl: "user/delAgent", //删除單条地址
				addUrl: "user/addAgentlevel", //添加/修改地址
				editStatusUrl:"user/editStatusAgent",//修改狀態地址

				tableData: [],
				form: {
                    
				},
				rules: {
					name: [{
						required: true,
						message: this.$t('aglevel.inpname'),
						trigger: 'blur',
					}],
					level: [{
						required: true,
						message: this.$t('aglevel.inplevel'),
						trigger: 'blur',
					}],
					rebate: [{
						required: true,
						message: this.$t('aglevel.inprebate'),
						trigger: 'blur',
					}],
					min: [{
						required: true,
						message: this.$t('aglevel.inpmin'),
						trigger: 'blur',
					}],
					max: [{
						required: true,
						message: this.$t('aglevel.inpmax'),
						trigger: 'blur',
					}],
					
					
				},
				agent_list: [],
				check_img_list:[]
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			//this.commonList('agentRule');
		},
		methods: {
			limitRebate(val) {
			    const n = Number(val)
			    if (!Number.isFinite(n)) { this.form.rebate = null; return }
			    const clamped = Math.min(100, Math.max(0, n))
			    this.form.rebate = Math.trunc(clamped)   // 只要整数
			  },
            validateParent(rule, value, callback) {
                if (this.form.id > 0) {
                    if (!value) {
                        return callback(new Error(this.$t('agentList.passwordLength'))); // 只有 type == 2 时才校验
                    }
                }
                callback(); // 其他情况不校验
            },
			//提交
			submit() {
				if (this.form.password != this.form.password2) {
					this.$message({
						message: this.$t('agentList.differentPasswords'),
						type: 'error'
					});
					return
				}
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('agentList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				// 增加
				if (!e) {
					// 初始化表單
					this.form = {
						name: "",
						min:0,
						max:0,
						type:1,
						rebate:null,
						level:null
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						name: e.row.name,
						min: e.row.min,
						max:  e.row.max,
						type:  e.row.type,
						rebate:  e.row.rebate,
						level:  e.row.level,
						
					}
					this.editIndex = e.row.id
				}
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type) {
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					this.rule = list.rule
					console.log(this.rule)
					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
            handleAvatarSuccessTg(res, file) {
				this.form.tg_qr = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.tgQrUrl = res.encryption.data.list.url
				}
			},
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				this.tableData = e.list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					type:-1,
					rule_id:'',
					time:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {
  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
